import { useQuery } from '@tanstack/react-query';
import { getUserData } from './services/users';

export const useUserData = () => {
	const { data } = useQuery({
		queryKey: ['getUserData'],
		queryFn: () => getUserData(),
		enabled: true,
	});

	return data?.data;
};
